<template>
    <li class="nav-item">
        <button class="nav-link bg-online-exam-red"
                data-toggle="modal"
                data-target="#uploadCrewActivity"
        >
            CREW ACTIVITY UPLOAD (OVERWRITE)
        </button>
        <div class="modal fade" id="uploadCrewActivity" tabindex="-1" role="dialog" aria-labelledby="uploadCrewActivityTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content text-dark" @submit.prevent="uploadExcelFile">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="uploadCrewActivityTitle">
                            UPLOAD CREW ACTIVITY EXCEL FILE
                        </h5>
                        <button type="button" id="closeUploadCrewActivity" class="close"
                                data-dismiss="modal" aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <div class="form-group form-row mb-1">
                            <label class="col col-sm-2 col-form-label font-weight-bolder text-right" for="excelFileInput" >
                                Excel File:
                            </label>
                            <div class="col col-sm-7" id="excelFileInputContainer">
                                <input type="file" id="excelFileInput"
                                       class="form-control form-control-xs"
                                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                >
<!--                                <span class="help-block">-->
<!--                                    <small><strong> error </strong></small>-->
<!--                                </span>-->
                            </div>
                            <div class="col col-sm-3">
                                <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
                                    <span class="fas fa-file-upload"></span>
                                    Upload
                                </button>
                            </div>
                        </div>

                    </div>

                </form>
            </div>
        </div>
    </li>
</template>

<script>

import { vueAppMixin } from "@/mixins/vueAppMixin";
import { mapActions } from 'vuex';
import { formMixin } from "@/mixins/formMixin";

export default {
    name: "CrewActivityUpload",

    mixins: [ vueAppMixin, formMixin ],

    methods: {

        ...mapActions([ 'uploadCrewActivity' ]),
        async uploadExcelFile() {
            if(await this.confirmUpdate()) {
                let formData = new FormData();
                let input = document.getElementById('excelFileInput');
                if (input.files && input.files[0]) {
                    let file = input.files[0];
                    formData.append('excelFile', file);
                }
                let updateCrewActivity = await this.uploadCrewActivity(formData);
                if(updateCrewActivity.result) {
                    this.successAlert('Crew Image Successfully Updated', 'UPDATE');
                    this.refreshInputFile('excelFileInputContainer');
                    document.getElementById('closeUploadCrewActivity').click();
                } else {
                    this.errorAlert('ERROR OCCURED!!', 'UPDATE');
                }
            }
        }

    }

}
</script>

<style scoped>
ul > li,
ul > li > button {
    border-radius: 3px !important;
    color: white;
    margin: 0 1px;
}
ul > li > button:focus,
ul > li > button:active {
    outline:none;
}

li>button.active, .nav-tabs .nav-link.active {
    background: white !important;
    font-weight: bold;
    color: #c53030 ;
}

.bg-online-exam-red {
    background-color: #c53030;
}
</style>
